import { ILog } from '@ftd/types'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'

export const apiPostLog = async (log: ILog): Promise<ILog> => {
  const res = await secureFetch(`${BASE_URL}/logs`, {
    method: 'POST',
    body: JSON.stringify(log),
  })
  if (!res.ok) throw new Error('Failed to create log')
  return res.json()
}
